import { UiModalVanila } from '@skillbox/front-box/dist/Modals/UiModal/UiModalVanila.js';
import { closePopupGtmTag } from '../../libs/gtm';

export default class UiModal extends UiModalVanila {
  constructor(slot, options, classes = {}) {
    super(slot, { ...options, closeHandler: closePopupGtmTag }, classes);

    this._blockTriggerName = options.blockTriggerName || 'Блок без названия';
    this._modalName = options.modalName || options.wrapperClass || 'Поп-ап без названия';
  }

  mounted() {
    window.$analytics?.push('popup-shown', {
      blockTriggerName: this._blockTriggerName,
      modalName: this._modalName
    });
  }

  unmounted() {
    window.$analytics?.push('popup-closed', {
      blockTriggerName: this._blockTriggerName,
      modalName: this._modalName
    });
  }
}
